<template>
    <div id="seriesLoadingBox" v-if="isLoading">

        <img class="d-none d-md-block mb-4" style="opacity:0.6;"
            src="/wp-content/themes/understrap-child/fidelio-templates/images/columnPlaceholder.svg" alt="">
        <img class="d-md-none mb-4" style="opacity:0.6;"
            src="/wp-content/themes/understrap-child/fidelio-templates/images/categoryPlacholderMobile.svg" alt="">
    </div>

    <div v-if="series && series.length" class="bg-white mb-4 px-5 py-1 rounded-corners-10">
        <div class="text-primary my-3">
            <h5 class="font-weight-bolder ml-3" style="font-size: x-large;">
                {{ $t('CategoryPage.series') }}
            </h5>
        </div>

        <div class="splide seriesSplide newFeatureSlider" aria-label="Slider for series">
            <div class="sands-article-vueslidercontainer splide__track">
                <div class="splide__list">

                    <div v-for="(serie, i) in series" :key="i" class="splide__slide">
                        <div class="row">
                            <div class="col-12 mt-3">
                                <div class="">
                                    <a @click="appendArtikelserienSlugToCurrentURL(serie.slug)" class="cursorPointer">
                                        <div class="d-md-flex d-inline">
                                            <div v-if="serie && serie.teaser && serie.teaser.xxx" class=" col-md-7">
                                                <img class="mb-md-5 img-square-wrapper-series" :src="serie.teaser.xxx"
                                                    alt="Card image cap">
                                            </div>
                                            <div class="ml-3 ml-md-0 mt-2 mt-md-0">
                                                <h4 v-if="serie && serie.name" class="text-break series-title"
                                                    itemprop="headline">
                                                    {{ serie.name }}
                                                </h4>
                                                <p v-if="serie && serie.description" class="card-text-series"> {{
                                                    truncatedAbstract(serie.description, 120) }}</p>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>

    </div>
</template>

<script>
import Splide from '@splidejs/splide';
import {
    Grid
} from '@splidejs/splide-extension-grid';
import CONCORD_QUERIES from "../../services/concord_queries.js";
import {
    watch
} from 'vue';
import useElementVisible from "../../services/elementVisibilityService.js";
import axios_queries from '../../services/axios_queries.js';

export default {
    name: "categorySeries",
    props: {
        settingsPerm: Object,
    },
    data() {
        return {
            isLoading: false,
            series: false,
            loadMorePossible: true,
            isDevMioActive: false,
            currentPage: 1,
            metaCount: 0,
            firstTimeInViewport: true,
        }
    },
    created() {
        this.isLoading = true;
        setTimeout(() => {
            this.box1Ref = document.getElementById('seriesLoadingBox');

            if (this.box1Ref) {
                const isVisible = useElementVisible(this.box1Ref);
                if (isVisible && isVisible.value && isVisible.value == true) {
                    this.firstTimeInViewport = false;
                    this.loadInitialData();
                }

                watch(isVisible, (newValue) => {
                    if (this.firstTimeInViewport && isVisible && newValue === true) {
                        this.firstTimeInViewport = false;
                        this.loadInitialData();
                    }
                    // Do something when isVisible changes
                });
            }
        }, 1000);
    if (this.settingsPerm && this.settingsPerm.isDevMioActive) {
      this.isDevMioActive = this.settingsPerm.isDevMioActive;
    }
    },
    methods: {

        loadInitialData() {
            let seriesLoadingParams = {
                page: 1,
                pagesize: 20,
                querystring: this.settingsPerm.cat,
                transientKey: this.settingsPerm.cat + '-cat-depending-series-vue',
                query: "cat-depending-series-vue",
                url: this.settingsPerm.ajaxUrl + '/wp-content/uploads/catpages/' + this.settingsPerm.cat + '-cat-depending-series-vue.json'
            };
            axios_queries.loadPublicData(seriesLoadingParams).then((concordData) => {
                if (concordData && concordData != null && concordData != undefined && concordData != '') {
                    if (concordData && concordData.advancedSearch && concordData.advancedSearch.series && concordData.advancedSearch.series.ArticleSeriesItems && concordData.advancedSearch.series.ArticleSeriesItems.length) {
                        this.displaySeries(concordData.advancedSearch.series.ArticleSeriesItems);
                    } else {
                        this.isLoading = false;
                    }
                } else {
                    this.isLoading = false;
                }
            })
        },

        displaySeries(series) {
            this.series = series;
            this.isLoading = false;
            this.mount_splide();
        },

        async loadMoreData() {
            // Make an API call to fetch more data
            const nextPage = this.currentPage + 1;
            let variablesForQuery = {
                page: nextPage,
                pagesize: 12,
                querystring: this.settingsPerm.cat,
            };
            let graphqlQuery = CONCORD_QUERIES.CAT_SPECIFIC_SERIES;
            let concordData = await axios_queries.getMoreData(graphqlQuery, variablesForQuery);
            if (concordData && concordData.advancedSearch && concordData.advancedSearch.series && concordData.advancedSearch.series.ArticleSeriesItems && concordData.advancedSearch.series.ArticleSeriesItems.length) {
                const newseries = concordData.advancedSearch.series.ArticleSeriesItems;
                // console.log('New series',newseries);
                this.series = [...this.series, ...newseries];
                // console.log('series',this.series);
                this.isLoading = false;
                this.currentPage = nextPage;
                this.mount_splide();
            }
        },
        appendArtikelserienSlugToCurrentURL(slug) {
            const currentURL = window.location.href;
            let updatedURL = currentURL + '/artikelserien/' + slug;
            if (this.isDevMioActive) {
                updatedURL = currentURL + '/series-article/' + slug;
            }
            window.location.href = updatedURL;
        },
        appendCourseSlugToCurrentURL(slug) {
            const URL = window.location.href;
            const updatedURL = URL + '/' + slug;
            window.location.href = updatedURL;
        },
        truncatedAbstract(text, length) {
            if (text.length <= length) {
                return text;
            } else {
                return text.substring(0, length) + '...';
            }
        },
        addMovedEventListener() {
            this.splide.on('moved', (newIndex) => {
                const lastCardIndex = newIndex + this.splide.options.perPage;
                // console.log('lastcardindex', lastCardIndex);
                // console.log('lenght', this.series.length);
                if (lastCardIndex === this.series.length - 2 && this.series.length > this.metaCount) {
                    this.loadMoreData();
                }
            });
        },
        mount_splide: function () {
            let thiz = this;
            setTimeout(function () {
                if (!thiz.splide) {
                    thiz.splide = new Splide('.seriesSplide', {
                        classes: {
                            prev: 'splide__arrow--prev xx',
                            next: 'splide__arrow--next xxx',
                            arrow: 'splide__arrow xxxx',
                        },
                        perPage: 1,
                        perMove: 1,
                        rewindByDrag: true,
                        gap: '1rem',
                        grid: {
                            dimensions: [
                                [2, 2]
                            ],
                        },
                        breakpoints: {
                            1700: {
                                perPage: 1,
                                grid: {
                                    dimensions: [
                                        [2, 2]
                                    ],
                                },
                            },
                            1699: {
                                perPage: 1,
                                grid: {
                                    dimensions: [
                                        [2, 2]
                                    ],
                                },
                            },
                            991: {
                                perPage: 1,
                                grid: {
                                    dimensions: [
                                        [1, 1]
                                    ],
                                },
                            },
                            767: {
                                perPage: 1,
                                grid: {
                                    dimensions: [
                                        [1, 1]
                                    ],
                                },
                            },
                        },
                        rewind: false,
                        pagination: false,
                        padding: {
                            right: '0rem',
                            left: '0rem',
                        }
                    });
                    thiz.splide.mount({
                        Grid
                    });
                    thiz.addMovedEventListener(); // Add event listener
                } else {
                    thiz.splide.refresh(); // Refresh the existing Splide instance
                }
            }, 100);
        },
    }
};
</script>

<style>
.card-text-series {
    word-break: break-all;
    color: black !important;
}

.series-title {
    font-size: 19.2px;
    color: black !important;
}

.img-square-wrapper-series {
    width: 100%;
    max-height: 165px;
}</style>
